import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION13: PdfComponent = {
  type: 'section',
  id: 's13',
  title: '13. Proceeds of Crime and Fraud',
  content: [
    {
      type: 'bulletList',
      id: 's13bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'Kanda and the Subscriber agree that neither party should ever be seen to be profiting from the proceeds of crime, including (without limitation) fraudulent activity. As such, any fraud cases where Kanda suffers financial loss will result in a restitution charge equal to 10% of such loss being charged to the Subscriber, representing a nominal level of profit that would have been made by the Subscriber from the fraudulent transactions.',
        },
      ],
      prefix: '13',
    },
  ],
};
